import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../index';

import './RadioField.scss';



export default function RadioField({ style, name, label, value, onChange, options, error }) {
  return (
    <div className="form-radio-field" style={style}>
      <Label type="form">{label}</Label>
      {options.map((option) => {
        return (
          <div key={option.value}>
            <input
              type="radio"
              value={option.value}
              name={name}
              id={option.value}
              checked={option.value === value}
              onChange={onChange}
            />
            <label htmlFor={option.value}>{option.label}</label>
          </div>
        );
      })}
      <div className="error">{error || '\u00A0'}</div>
    </div>
  );
}

RadioField.propTypes = {
  name: PropTypes.string.isRequired,
  style: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

RadioField.defaultProps = {
  style: {},
  label: '',
  value: '',
  error: null,
};
